




























































import PoiButton from "./PoiButton.vue";

export default {
  components: { PoiButton },
  props: {
    currentPoi: Object,
    pois: Object,
  },
  data() {
    return {};
  },
  mounted: function () {
    //this.changeLocation(this.location);
  },
  methods: {
    navigate: function (loc) {
      this.$root.playClick();
      this.$emit("setContentEnabled", false);
      this.$emit("navigate", loc);
    },
  },
};
